export default __webpack_public_path__ + "static/media/c501c162725691 4.15a2fafb.png";